import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { DURATIONS, EASING, RADII } from 'styles/consts'

interface IDropdownButtonWrapperProps {
  $isOpen: boolean
  $disabled: boolean
}

interface IArrowWrapperProps {
  $isOpen: boolean
}

export const DropdownButtonWrapper = styled.div<IDropdownButtonWrapperProps>`
  position: relative;
  height: 100%;
  width: 100%;
  border-radius: ${RADII.field};
  border: ${props =>
    `1px solid ${props.$isOpen ? COLORS.primary : COLORS.border}`};
  background: ${COLORS.surface};
  cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
  opacity: ${props => (props.$disabled ? 0.5 : 1)};
  transition:
    border-color ${DURATIONS.base} ${EASING.out},
    opacity ${DURATIONS.base} ${EASING.out};
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;

  &:hover {
    border: ${props => !props.$isOpen && `1px solid ${COLORS.borderHover}`};
  }
`

export const ContentWrapper = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
`

export const ArrowWrapper = styled.div<IArrowWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform ${DURATIONS.base} ${EASING.out};
  transform: rotate(${({ $isOpen }) => ($isOpen ? '180deg' : '0deg')});
  margin-left: 8px;

  svg {
    width: 12px;
    height: 12px;
    color: ${COLORS.textPrimary};
  }
`
